// WRITEY JAVASCRIPT MASTER
// placeholder for collected files


// WRITEY TOOLS

var WriteyTools = (function($) {

	'use strict';

	// paint max
	var maxsqft = 1000;
	var maxpaint = 1000;

	// cart
	var productname, productvariants, carttotal, cartquantity, variantprice, cartadd;
	var calcwidth, calcheight, calcsum, calctotal, calcresult, calcorder, calcprevious, calcradio;

	// free banner
	var usefreebanner = false;


	// INIT

	var init = function() {

		// toys
		initRegionCheck();
		svgSwap();
		initNavScroller();
		initSubnav();
		initMobileNav();
		initJsonData();
		requireNumberInput();
		initQuantityButtons();
		initPaintInline();
		initPaintButtons();
		initPaintCalculator();
		initProductCarousel();
		initTreePanel();
		initShoppingCart();
		initRelated();
		initDistance();
		// initHelpNav();
		initProductVideo();

	};


	// SVG SWAP
	// creates inline code

	var svgSwap = function() {

		$('img.svgfile').each(function() {

			var $img = $(this);
			var imgURL = $img.attr('src');
			var attributes = $img.prop("attributes");

			$.get(imgURL, function(data) {

				// get svg tag, ignore the rest
				var $svg = $(data).find('svg');

				// remove invalid xml tags
				$svg = $svg.removeAttr('xmlns:a');

				// loop through img attributes and apply on svg
				$.each(attributes, function() {
					$svg.attr(this.name, this.value);
				});

				// replace img with svg
				$img.replaceWith($svg);

			}, 'xml');

		});

	};


	// NAV SCROLLER

	var initNavScroller = function() {

		var writeybody = $('body');

		writeybody.waypoint(function(direction) {

				if (direction == 'down') {
					hideFreeBanner();
					writeybody.addClass('navcollapse');
				}

				else {
					showFreeBanner();
					writeybody.removeClass('navcollapse');
				}
			},
			{ offset: '-50px' }
		);

	};


	// SUBNAV

	var initSubnav = function() {

		$('.navitem').mouseenter(function () {
			$(this).addClass('active');
		});

		$('.navitem').mouseleave(function () {
			$(this).removeClass('active');
		});

	};


	// MOBILE NAV TOGGLE

	var initMobileNav = function() {

		var writeybody = $('.writeybody');

		$('#hamburger').on('click', function() {

			writeybody.toggleClass('navopen');

		});

	};


	// REQUIRE NUMBER INPUT

	var requireNumberInput = function() {

		var entry, min, max;

		$('input[type="num"]').on('keyup', function() {

			if ($(this).hasClass('boardsize-input')) { return; }

			entry = parseFloat($(this).val());

			if (!$.isNumeric(entry)) {
				min = $(this).attr('min');
				$(this).val(min);
			}

			if ($(this).hasClass('pcalc-input')) {
				calculatePaint();
			}

			if ($(this).hasClass('distanceamount')) {
				if (entry < 1) { $(this).val(1); }
			}

		});

	};


	// QUANTITY BUTTONS

	var initQuantityButtons = function() {

		$('.qty-toggle').on('click', function() {

			var button = $(this);
			var target = button.parent().find('input[type=num]');

			var oldValue = parseFloat(target.val());
			var increment = parseFloat($(this).data('increment'));
			var minVal = increment;
			var newVal = increment;

			if (button.hasClass('pcalc')) {
				minVal = 0;
			}

			if (button.hasClass('qty-inc')) {
				newVal = oldValue + increment;
			}
			else {
				newVal = oldValue - increment;
			}

			if (button.hasClass('sqft')) {
				newVal = Math.ceil(newVal / increment) * increment;
				if (newVal > maxsqft) { newVal = maxsqft; }
			}

			if (newVal < minVal) { newVal = minVal; }

			target.val(newVal);

			// calculator
			if (button.hasClass('sqft')) {
				updatePaint();
			}

			// calculator
			if (button.hasClass('pcalc')) {
				calculatePaint();
			}

		});

	};


	// PAINT CALCULATOR / INLINE

	var initPaintInline = function() {

		var calcrow, calcnum;

		var calcrows = $('#paintcalc-rows');

		cartadd = $('#add');
		calcresult = $('#paintcalc-result');
		calcorder = $('#paintcalc-order');

		if (calcrows.length) {
			cartadd.addClass('disabled');
		}

		// add row
		$('#paintcalc-addrow').on('click', function(e) {
			e.preventDefault();
			calcrow = $('#paintcalc-clone').clone().removeAttr('id');
			$(calcrow).appendTo(calcrows).slideDown(function() {
				$(this).css('display', '');
			});
		});

		// delete row
		calcrows.on('click', '.paintcalc-delete', function(e) {
			e.preventDefault();
			$(this).parents('.calcrow').slideUp('normal', function() {
				$(this).remove();
				updatePaintInline();
			});
		});

		// remove 0
		calcrows.on('focus', '.paintcalc-input', function(e) {
			e.preventDefault();
			calcnum = $(this).val();
			if (calcnum == 0) { $(this).val(''); }
		});

		// change entry
		calcrows.on('change keyup', '.paintcalc-input', function(e) {
			e.preventDefault();
			calcnum = $(this).val();
			if ( (calcnum < 0) || (!$.isNumeric(calcnum)) ) { $(this).val(0); }
			updatePaintInline();
		});

	};


	// PAINT TOTAL / INLINE
	// paintsizes in product-dropdown-js.liquid

	function updatePaintInline() {

		// init sum
		calcsum = 0;

		// cycle through calc rows
		$('#paintcalc-rows .calcrow').each(function(){
        	calcwidth = $(this).find('.calcwidth').val();
        	calcheight = $(this).find('.calcheight').val();
        	calcsum += (calcwidth * calcheight);
    	});

		// update subtotal
		calcresult.text(calcsum);

		// 0 or max?
		if ( (calcsum > maxpaint) || (calcsum == 0) ) { calctotal = calcsum; }

		// find nearest paint size
		else {
			calcprevious = 0;
			paintsizes.forEach(function(size) {
				if ( (calcsum > calcprevious) && (calcsum <= size) ) {
					calctotal = size;
				}
				calcprevious = size;
			});
		}

		// update total
		calcorder.text(calctotal);

		// disable add button
		if (calctotal == 0) {cartadd.addClass('disabled'); }

		// trigger system
		else {
			cartadd.removeClass('disabled');
			calcradio = 'ProductSelect-option-size-' + calctotal + '-sq-ft';
			$("label[for='" + calcradio + "']").trigger('click');
		}

	}


	// PAINT BUTTONS

	var initPaintButtons = function() {

		if ($('#quantity').hasClass('product-paint')) {

			$('#sqftNum').on('change keyup', function(e) {
				e.preventDefault();
              	// console.log('Quantity updated.');
              	var sqft = $(this).val();
              	if (sqft > maxsqft) { $(this).val(maxsqft); }
				updatePaint();
			});

		}

	};


	// update paint
	function updatePaint() {

		var updated = false;
		var sqft = parseInt($('#sqftNum').val());
		var quantity = 25;

		// nearest quantity
		paintsizes.forEach(function(size) {
			if (!updated) {
				if (sqft <= size) {
					quantity = size;
					updated = true;
				}
			}

		})

		// maxed out
		if (!updated) {
			quantity = 1000;
		}


		// button
		var radioid = 'ProductSelect-option-size-' + quantity + '-sq-ft';

		$("label[for='" + radioid + "']").trigger('click');

		// $('#' + radioid).trigger('click');

		// display
		$('#paint-sqft').text(quantity);

		// console.log(radioid);

	}


	// PAINT CALCULATOR

	var initPaintCalculator = function() {

		$('#pcalc-add').on('click',function(e) {
			e.preventDefault();
			var sqft = parseInt($('#pcalc-sqft').text());
			if (sqft < 1) { return; }
			if (sqft > maxsqft) { sqft = maxsqft; }
			$('#sqftNum').val(sqft);
			updatePaint();
			$("#calc-modal").modal('hide');
		});

	};


	// CALCULATE PAINT

	function calculatePaint() {

		var widthFeet = parseFloat($('#pcalc-width-feet').val());
		var widthInch = parseFloat($('#pcalc-width-inches').val()) / 12;
		var heightFeet = parseFloat($('#pcalc-height-feet').val());
		var heightInch = parseFloat($('#pcalc-height-inches').val()) / 12;

		var sqft = (widthFeet + widthInch) * (heightFeet + heightInch);

		$('#pcalc-sqft').text(Math.ceil(sqft));

	}


	// PRODUCT CAROUSEL
	// includes liquid variables

	var initProductCarousel = function() {

		$('.product-carousel').owlCarousel({
			singleItem:true,
			loop:true,
			nav:true,
			responsive: {
				0: { items: 1 },
				600: { items: 1 },
				1000: { items: 1 }
			},
			navText : ['<img src="">', '<img src="">']
		});

	};


	// TREE PANEL

	var initTreePanel = function() {

		// are we there?
		if ($('.trees-planted').length == 0) { return; }

		// trigger
		var trigger = true;

		$(window).scroll(function() {

			var oTop = $('.trees-planted').offset().top - window.innerHeight;

			if ( (trigger) && ($(window).scrollTop() > oTop) ) {

				$('.counter').each(function() {

					var $this = $(this),
					countTo = $this.attr('data-count');

					$({ countNum: $this.text() }).animate(

						{
							countNum: countTo
						},

						{
							duration: $this.attr('data-duration'),
							step: function() {
								$this.text(Math.floor(this.countNum)).digits();
							},
							complete: function() {
								$this.text(this.countNum).digits();
							}

						}

					);

				});

				trigger = false;

			}

		});

		// add commas to number
		$.fn.digits = function() {
			return this.each(function() {
				$(this).text( $(this).text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") );
			})
		}

	};


	// SHOPPING CART AJAX

	// json data
	var initJsonData = function() {

		if ($('#ProductJson').length) {
			var productjson = JSON.parse($('#ProductJson').html());
			productname = productjson.title;
			productvariants = productjson.variants;
			variantprice = 0;
		}

		if ($('#CartJson').length) {

			// get cart
			var cartjson = JSON.parse($('#CartJson').html());
			carttotal = cartjson.total_price;
			cartquantity = cartjson.item_count;

			// filter writeydesk
			// cartjson.items.forEach(function(item) {
			//	if (item.product_title == 'WriteyDesk') {
			//		var quantity = item.quantity;
			//		var price = item.price;
			//		var deduct = quantity * price;
			//		carttotal = carttotal - deduct;
					// console.log(carttotal + ' / ' + deduct);
			//	}
			// })

			// update freebanner
			updateFreeBanner();

		}

	}

	// submit product
	var initShoppingCart = function() {

		$('.shopify-product-form').submit(function(e) {
			e.preventDefault();

			// init vars
			var quantity = 1;
			var myform = $(this);

			// convert form fields to object
			var values = {};
			$.each($($(this)).serializeArray(), function(i, field) {
				values[field.name] = field.value;
			});

			console.log(values);

			// set vars
			var variantid = values.id;
			quantity = parseInt(values.quantity);

			// boardsize
			var boardsize = '';
			if (typeof values.boardsize !== 'undefined')	 {
				boardsize = values.boardsize;
			}

			// distance page
			var distanceproduct = '';
			if (typeof values.distancename !== 'undefined')	 {
				distanceproduct = values.distancename;
			}

			if (typeof values.distanceprice !== 'undefined')	 {
				variantprice = values.distanceprice;
			}

			// fire!
			// addItem: function(id, quantity, properties, options) {
			CartJS.addItem(variantid, quantity, {
				'Custom Size': boardsize,
				'success': function(data, textStatus, jqXHR) {

					// update display
					ajaxDisplayUpdate (variantid, quantity);

					// distance page
					if (distanceproduct.length > 0) {
						console.log('distance page');
						$('#cartadd-productname').text(distanceproduct);
						$('#cartadd-modal').modal('show');
					}

					// popup!
					else {
						var productname = $('#popup-productname').text();
						$('#cartadd-productname').text(productname);

						if (relatedneon) {
							$('.relatedmarkers').css('display', 'none');
							$('.relatedneon').css('display', 'flex');
						}
						else {
							$('.relatedmarkers').css('display', 'flex');
							$('.relatedneon').css('display', 'none');
						}

						var related = $('#popup-related').html();
						$('#cartadd-related').html(related);
						$('#cartadd-modal').modal('show');
					}

				}
			});

		});

	};

	// submit from modal
	var initRelated = function() {

		$('#cartadd-modal').on('click', '.addrelated', function(e) {
			e.preventDefault();

			var buttonchosen = $(this);
			var variantid = buttonchosen.data('variantid');
			variantprice = buttonchosen.data('variantprice');
			var quantity = 1;

			// console.log(variantid);

			CartJS.addItem(variantid, quantity, {
				"success": function(data, textStatus, jqXHR) {

					// update button
					buttonchosen.html('Added &#10004;');
					buttonchosen.addClass('disabled');

					// update display
					ajaxDisplayUpdate(variantid, quantity);

				}
			});

		});

	};

	// distance page
	var initDistance = function() {

		var itemid;
		var direction;
		var currentval;

		$('.distancequantity').on('click', function(e) {
			e.preventDefault();

			itemid = $(this).data('id');
			currentval = parseInt($('#amount-' + itemid).val());

			if ($(this).hasClass('up')) {
				currentval = currentval + 1;
			}

			else {
				if (currentval > 1) { currentval = currentval - 1; }
			}

			$('#amount-' + itemid).val(currentval);

		});

		// modal
		$('#distanceclose').on('click', function(e) {
			// console.log('close modal');
			$('#distance-modal').modal('hide');
			$('#distance-modal').removeClass('show').delay(150).css('display', 'none');
			$('.modal-backdrop').removeClass('show').delay(150).css('display', 'none');
			$('body').removeClass('modal-open');
		});

	};


	// display update
	function ajaxDisplayUpdate (variantid, quantity) {

		// update cart total
		var price = 0;

		// from popup
		if (variantprice != 0) {
			price = variantprice;
			variantprice = 0;
		}

		// from page
		else {
			productvariants.forEach(function(variant) {
				// console.log(variantid + ' / ' + carttotal + ' / ' + price + ' / ' + quantity);
				if (variant.id == variantid) {
					price = variant.price;
				}
			})
		}

		// update cart bubble
		cartquantity = cartquantity + quantity;
		$('#cart-items').text(cartquantity);
		$('#mobilenavcartcount').text(cartquantity);

		// desk diversion
		// if (productname == 'WriteyDesk') { return; }

		// update cart total
		carttotal = carttotal + (price * quantity);

		// update freebanner
		updateFreeBanner();

	}

	// freebanner
	function updateFreeBanner() {

		// init banner
		var freelevel = 15000; // 4900; // 5000;
		var freeclass = '';
		var freetext = 'Free US shipping on <a href="/pages/help">orders over $150</a>';
		// var freetext = 'Free shipping over $49<span class="mobilehide"> + free returns</span>';
		var cartgap = 0;

		// all free
		// var freetext = 'Free shipping + free returns';
		// $('#freetext').html(freetext);
		// return;

		if (carttotal >= freelevel) {
			freeclass = 'filled';
			freetext = 'Free shipping achieved!';
		}

		else if (carttotal > 0) {
			freeclass = 'filling';
			cartgap = Math.floor((freelevel - carttotal) / 100);
			freetext = 'Only $' + cartgap + ' away from <a href="/pages/help">free shipping!</a>';
		}

		// update banner
		$('#freebanner').removeClass('filling filled').addClass(freeclass);
		$('#freetext').html(freetext)

	}


	// HELP NAV

	var initHelpNav = function() {

		$('.help-nav-item').click(function() {
			$('.help-nav-item').removeClass('active');
			$(this).addClass('active');
		});

	};


	// REGION CHECK

	var initRegionCheck = function() {

		var wbcookie = Cookies.noConflict();
		var wbcookiename = 'wbcountry';
		var wbcookieregion = 'wbregion';
		var wbcountry = wbcookie.get(wbcookiename);
		var wbregion = wbcookie.get(wbcookieregion);
		var ipstack = 'https://api.ipstack.com/check?access_key=' + 'c31a0337bbfdf48871a274e5fa4a1a2d' + '&fields=country_code,region_code';

		if ( (typeof wbcountry === 'undefined') || (typeof wbregion === 'undefined') ) {

			wbcountry = 'US';

			$.ajax({
				url: ipstack,
				type: 'GET',
				success: function(location) {
					// console.log(location);
					if (typeof location.country_code !== 'undefined') {
						wbcountry = location.country_code;
						wbcookie.set(wbcookiename, wbcountry, { expires: 1 });
					}
					if (typeof location.region_code !== 'undefined') {
						wbregion = location.region_code;
						wbcookie.set(wbcookieregion, wbregion, { expires: 1 });
					}
				},
				complete: function(location) {
					regionprocess(wbcountry, wbregion);
				}
			});
		}

		else {
			regionprocess(wbcountry, wbregion);
		}

		function regionprocess (wbcountry, wbregion) {
			// console.log(wbcountry + ' / ' + wbregion);

			if (wbcountry === 'US') {
				if ( (wbregion !== 'AK') && (wbregion !== 'HI') ) {
					usefreebanner = true;
					showFreeBanner();
				}
			}

			else if (wbcountry === 'AU') {
				window.location = 'https://writeyboard.com.au/';
			}

		}

	}

	function showFreeBanner() {
		if (usefreebanner) {
			// $('#freebanner').addClass('reveal');
			$('#freebanner').slideDown(200);
			$('#pagewrap').addClass('bannerpad');
		}
	}

	function hideFreeBanner() {
		// $('#freebanner').removeClass('reveal');
		$('#freebanner').slideUp(200);
		// $('#pagewrap').removeClass('bannerpad');
	}


	// PRODUCT VIDEO

	var initProductVideo = function() {

		// load
		$(window).on('load', function() {

			if ($('#productvideo').length) {
				var videosrc = $('#productvideo source').data('src');
				$('#productvideo source').attr('src', videosrc);
				$('#productvideo')[0].load();
				$('#productvideo')[0].play();
			}

		});

	};


	// RETURN

	return {
		init: init,
	};

}(jQuery));

WriteyTools.init();
